import React from "react"
export function IndiaFlag(props) {
  return (
    <svg viewBox="0 0 24 16" {...props}>
      <g
        id="prefix__Double-Color-Icons"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <g id="prefix__India" fillRule="nonzero">
          <g id="prefix__india">
            <path
              id="prefix__Rectangle"
              stroke="#CCC"
              strokeWidth={0.5}
              fill="#FFF"
              d="M.25.25h23.5v15.5H.25z"
            />
            <path id="prefix__Rectangle" fill="#FF9811" d="M0 0h24v5.3H0z" />
            <path id="prefix__Rectangle" fill="#6DA544" d="M0 10.7h24V16H0z" />
            <circle id="prefix__Oval" fill="#0052B4" cx={12} cy={8} r={2.1} />
            <circle id="prefix__Oval" fill="#F0F0F0" cx={12} cy={8} r={1.3} />
          </g>
        </g>
      </g>
    </svg>
  )
}
